module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (216).bfc15641.jpg";